import React, { useState, useEffect, useContext } from "react";
import {
  CardElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import CardSection from "./cardSection";
import axios from "axios";
import { useHistory } from "react-router-dom"
import { AuthContext, baseUrl } from "@app/providers";
import { Button, Toast, Input, ProfileUpdtaeDialog, AuthFail, Dialog, Icon } from "@app/components";
import { CommonLabel, FlexWrapper, FormFlexWrapper } from "@app/components/commonStyles";
import { useLocation, emailPattern, user } from "@app/utils";
import { useForm } from "react-hook-form";
import { ProfileSuccessText, SuccessContainer } from "@app/components/profileEditSuccess/success-components";
import { SuccessText } from "../signUp/sign-up.component";

const SubmitButton = ({ processing, error, children, disabled }: any) => (
  <button
    className={`SubmitButton ${error ? "SubmitButton--error" : ""}`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? "Verifying..." : children}
  </button>
);

const ErrorMessage = ({ children }: any) => (
  <p className="ErrorMessage" role="alert">
    {/* <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg> */}
    {children}
  </p>
);

type Props = {
  SetShowPendingView: (e: any) => void;
}

const CheckoutForm = ({ SetShowPendingView }: Props) => {
  const stripe = useStripe();
  const elements: any = useElements();
  const { navigate } = useLocation();
  const [error, setError] = useState<any>(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [showToast, setShowToast] = useState<any>(null);
  const [showAuth, setShowAuth] = useState<any>(null);
  const { setUserInfo }: any = useContext(AuthContext);
  let history = useHistory();
  const [toastMessage, setToastMessage] = useState<any>({
    type: "success",
    title: "Authentication Success",
    message: "Authentication verified successfully",
  });

  const [authFail, setAuthFail] = useState<any>({
    type: "failed",
    title: "Please Try again ",
    message: "Authentication Failed",
  });

  const [userData, SetUserData] = useState<any>();
  const {
    register,
    handleSubmit,
    errors,
    setValue
  }: any = useForm({});

  useEffect(() => {

    let paymentSource: any = localStorage.getItem("paymentSource");
    let key = paymentSource === "signUp" ? "paymentUser" : "userData";
    let data: any = localStorage.getItem(`${key}`);
    if (data) {
      data = JSON.parse(data);
      if (data["userJson"]) {
        data = data.userJson;
      }
      SetUserData(data);
      let body: any = {
        email: data.email,
        name: data.firstName + " " + data.lastName,
        userId: data.userId
      }
      setValue("email", body.email);
      setValue("name", body.name);

    } else {
      navigate('/sign-in', { replace: true });
    }
  }, [SetShowPendingView])

  const onSubmit = async (data: any) => {
    setFormSubmitted(true);

    if (!stripe || !elements || !cardComplete) {
      return;
    }


    if (error) {
      if (elements) {
        elements.getElement("card").focus();
      }
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }


    getSecretKey(data).then(async (resp: any) => {
      if (resp.status === 200) {
        const paymentMethod = {
          payment_method: {
            type: "card",
            card: elements.getElement(CardElement),
            billing_details: {
              name: data.name,
              email: data.email,
              "address": {
                // "city": "Mirzapur",
                // "country": "BD",
                // "line1": "Dhaka",
                // "line2": "",
                "postal_code": data.zip,
                // "state": "BD-63"
              },
            }
          }
        };
        const payload = await stripe.confirmCardSetup(resp.data.setupIntent.client_secret, paymentMethod);
        setProcessing(false);

        if (payload.error) {
          setError(payload.error);
          onPaymentFailure(payload.setupIntent)
        } else {
          onPaymentSuccess(payload.setupIntent)
        }
      }
    }).catch(err => {
      console.log(err);
    })

  };


  function getSecretKey(data: any) {
    const bodyFormData = new FormData();
    for (const key in data) {
      bodyFormData.append(key, data[key]);
    }
    bodyFormData.append("userId", userData.userId);
    return axios({
      method: "POST",
      url: baseUrl + `users/createSetupIntent`,
      data: bodyFormData,
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    })
  }

  function onCancel() {
    SetShowPendingView(true)
    // localStorage.clear();
    // setUserInfo(null);
    // navigate('/sign-in',{replace:true});
  }

  function onPaymentSuccess(payload: any) {
    setShowToast(true);
  }

  function onPaymentFailure(payload: any) {
    setShowAuth(true);
  }

  function onSucessRoute() {
    let key = "/sign-in"
    let data = localStorage.getItem("parentDataSource") || "";

    let jsonData = JSON.parse(data);
    jsonData.userJson.ageVerfiedflag = 1;
    setUserInfo(jsonData);

    if (userData && userData.userType === "educator") {
      key = "/educator";
    } else {
      key = "/linked-child";
    }
    localStorage.setItem("paymentSource", "signIn");
    navigate(`${key}`, { replace: true });

  }

  function closeToast() {
    setShowToast(false)
    onSucessRoute();
  }
  function closeAuthFail() {
    setShowAuth(false)
    // onSucessRoute()
  }

  function addChild() {

    let data = localStorage.getItem("parentDataSource") || "";
    let jsonData = JSON.parse(data);
    jsonData.userJson.ageVerfiedflag = 1;
    setUserInfo(jsonData);
    navigate('/profile')
    //  setShowToast(false)

  }


  return (
    <>
      <form className="Form" onSubmit={handleSubmit(onSubmit)} >
        <FormFlexWrapper className="mb-0">
          <div className="only-child">
            <Input
              label="Card Holder's Name"
              placeholder="Enter Card Holder's name"
              name="name"
              autoFocus={true}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.name && "Please enter Card Holder's Name"}
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="mb-0">
          <div className="only-child">
            <Input
              type="email"
              label="Card Holder's Email Address"
              placeholder="Enter Card Holder's Email Address"
              name="email"

              register={register({
                required: true,
                pattern: emailPattern,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              // error={errors.email && "Please enter Card Holder's Email Address"}
              error={
                (errors.email &&
                  errors.email.type === "required" &&
                  "Please enter Card Holder's Email Address") ||
                (errors.email &&
                  errors.email.type === "pattern" &&
                  "Please enter valid Email Address")
              }
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="only-child">
            <CommonLabel>Card Details</CommonLabel>
            <CardSection
              onChange={(e: any) => {
                setError(e.error);
                setCardComplete(e.complete);
              }}
            />
            {formSubmitted && !cardComplete && !error && <ErrorMessage>Please enter Card Details</ErrorMessage>}
            {formSubmitted && error && <ErrorMessage>{error.message}</ErrorMessage>}
          </div>
        </FormFlexWrapper>



        <FormFlexWrapper>
          <div className="only-child">
            <Input
              label="Billing Zip Code"
              placeholder="Enter Billing Zip Code"
              name="zip"
              type="number"
              register={register({
                required: true,
                maxLength: 5,
                minLength: 5,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={(errors.zip && errors.zip.type === 'required' && "Please enter Billing Zip Code") ||
                (errors.zip && errors.zip.type === 'maxLength' && "Please enter valid Zip Code") ||
                (errors.zip && errors.zip.type === 'minLength' && "Please enter valid Zip Code")
              }
            />
          </div>
        </FormFlexWrapper>

        <FlexWrapper className="justify-end mt-3">
          <Button
            variant="text"
            customClass="mr-1 mr-sm-0 mb-sm-1"
            type="button"
            onClick={onCancel}
          >
            Cancel
        </Button>
          <SubmitButton processing={processing} error={error} disabled={!stripe}>
            Verify
        </SubmitButton>
        </FlexWrapper>
      </form>
      {showToast && (
        // <ProfileUpdtaeDialog
        //   onClose={() => closeToast()}
        //     message={toastMessage.title}
        //     subtitle={toastMessage.message}
        //     buttonMessage={''}
        //     addChild={()=> addChild()}

        // />
        <Dialog noTitle={true}
          onClose={closeToast}
        >
          <SuccessContainer>
            <Icon name="signsuccess" />
            <ProfileSuccessText className="success-color">Authentication Success</ProfileSuccessText>
            <SuccessText>
              Authentication verified successfully.
          {userData.userType === "parent" ? <> <br />  Click here to navigate to your
           <button
                  className="anchor-tag"
                  type="button"
                  onClick={addChild}
                >
                  Home Account
           </button> <br />
           to Add/Link child(ren) to your account.
           </> : ''}
            </SuccessText>
          </SuccessContainer>
        </Dialog>
      )}
      {showAuth && (
        <AuthFail onClose={() => closeAuthFail()}
          message={authFail.title}
          subtitle={authFail.message}
          buttonMessage={''} />
      )

      }
    </>

  );
};


export default CheckoutForm;